import React, { useEffect, useRef, useState } from 'react';

export default function LazyOnVisible({ children, rootMargin = '800px 0px', threshold = 0 }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (visible) return;
        if (typeof window === 'undefined') return;
        if (!ref.current) return;

        // Fallback: if IntersectionObserver is not supported, mount immediately.
        if (typeof window.IntersectionObserver !== 'function') {
            setVisible(true);
            return;
        }

        const observer = new window.IntersectionObserver(
            entries => {
                const entry = entries[0];
                if (entry?.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { root: null, rootMargin, threshold }
        );

        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [rootMargin, threshold, visible]);

    return (
        <>
            <div ref={ref} />
            {visible ? children : null}
        </>
    );
}

